import { Box, Button, Grid2, Typography } from '@mui/material';
import { RecentlyCreatedReportRow } from '@tap/data-providers';
import { IComponentCss, PeriodSelectType } from '@tap/mui-ui';
import { RecentlyCreatedIssuesChart } from './RecentlyCreatedIssuesChart';
import { RecentlyCreatedIssuesTable } from './RecentlyCreatedIssuesTable';

/* Таблица Недавно созданные заявки
*/

// Цвета для ячеек со значениями
const css: IComponentCss = {
    contentWrap: {
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
    },
    optionsButton: {
        zIndex: 1,
        marginBottom: '5px',
        float: 'right',
    },
    chartWrap: {
        width: '90%',
        marginBottom: '40px',
    },
};

type RecentlyCreatedIssuesReportProps = {
    periodType: PeriodSelectType,
    reportData: RecentlyCreatedReportRow[],
    onOptionsButtonClick: () => void,
}

export const RecentlyCreatedIssuesReport = ({ periodType, reportData, onOptionsButtonClick }: RecentlyCreatedIssuesReportProps) => {
    return (
        <Box sx={css.contentWrap}>
            <Grid2 width={'100%'}>
                <Button
                    size='small'
                    sx={css.optionsButton}
                    onClick={onOptionsButtonClick}
                >
                    Параметры отчёта
                </Button>
            </Grid2>

            {!reportData.length && (
                <Typography variant='h2'>Нет данных</Typography>
            )}

            {Boolean(reportData.length) && (
                <>
                    <Grid2 sx={css.chartWrap}>
                        <RecentlyCreatedIssuesChart
                            reportData={reportData}
                            periodType={periodType}
                        />
                    </Grid2>
                    <RecentlyCreatedIssuesTable
                        reportData={reportData}
                    />
                </>
            )}
        </Box>
    );
}

